<h1 mat-dialog-title>Edición de paciente</h1>
<app-patient-edit [patientId]="patientId" [firstName]="firstName" [lastName]="lastName" [document]="document" (onClose)="onClose($event)"></app-patient-edit>